import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, retry } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { Constants } from '@constants';
import { environment} from '@env';
import { BacklinkCommitment, Domain } from '@models';

import { HttpHelper } from '@shared/util/httpHelper';

@Injectable()
export class CommitmentHttp {

    private baseUrl: string = '';

    constructor( 
        private http: HttpClient ,
        private httpHelper: HttpHelper) {
    }

    getInboundBacklinkCommitments = (domainId: string): Observable<BacklinkCommitment[]> => {
        return this.http.get<BacklinkCommitment[]>(this.baseUrl + 
            Constants.ServiceUrls.GetInboundBacklinkCommitments.replace('{domainId}', domainId))
        .pipe(
            retry(3), // retry a failed request up to 3 times
            catchError((err) => this.httpHelper.handleError(err)) // then handle the error
          );
    }

    getOutboundBacklinkCommitments = (domainId: string): Observable<BacklinkCommitment[]> => {
        return this.http.get<BacklinkCommitment[]>(this.baseUrl + 
            Constants.ServiceUrls.GetOutboundBacklinkCommitments.replace('{domainId}', domainId))
        .pipe(
            retry(3), // retry a failed request up to 3 times
            catchError((err) => this.httpHelper.handleError(err)) // then handle the error
          );
    }
}
